var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconDownArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.8281 7.14844L15 8.32031L10 13.3203L5 8.32031L6.17188 7.14844L10 10.9766L13.8281 7.14844Z",
    fill: "#7E7E7E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDownArrow);
export default __webpack_public_path__ + "static/media/icon-down-arrow.f85045bc80f4d95529a8a05a96bcff96.svg";
export { ForwardRef as ReactComponent };